import React from 'react';
import { theme } from '@components-shared/src/stitches';
import { EXPLORE_TYPES } from '../schema';
import { ExploreCard } from './ExploreCard';
import { onExploreCardClick } from './More';

export const ExploreMoreSection = () => {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex justify-between">
        <h3 className="font-title text-title-m font-medium md:text-title-l">Explore All</h3>
      </div>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-4 lg:grid-cols-5 xl:grid-cols-6">
        <ExploreCard
          key="upcomingDrops"
          label="Upcoming Drops"
          className="bg-green300"
          onClick={() => onExploreCardClick({ type: EXPLORE_TYPES.UPCOMING_DROPS })}
          backgroundColor=""
        />
        <ExploreCard
          key="sounds"
          label="Sounds"
          backgroundColor={theme.colors.userEducation600.toString()}
          onClick={() => onExploreCardClick({ type: EXPLORE_TYPES.SOUNDS })}
        />
        <ExploreCard
          key="artists"
          label="Artists"
          backgroundColor={theme.colors.accent700.toString()}
          onClick={() => onExploreCardClick({ type: EXPLORE_TYPES.ARTISTS })}
        />
        <ExploreCard
          key="playlists"
          label="Playlists"
          backgroundColor={theme.colors.brand600.toString()}
          onClick={() => onExploreCardClick({ type: EXPLORE_TYPES.PLAYLISTS })}
        />
        <ExploreCard
          key="collectors"
          label="Collectors"
          backgroundColor={theme.colors.base600.toString()}
          onClick={() => onExploreCardClick({ type: EXPLORE_TYPES.COLLECTORS })}
        />
      </div>
    </div>
  );
};
